import React from 'react';
import { Box, useTheme } from '@mui/material';
import { PageProps } from 'gatsby';
import Layout from 'components/Layout';
import Toc from './PostContents/TocCard';
import Navigation from './Navigation';
import PostContents from './PostContents';
import assert from 'utils/assert';
import { usePostViewCount } from './usePostViewCount';
import { PostPageContext } from './models';

const PostPage = ({ data, pageContext }: PageProps<Queries.PostPageQuery, PostPageContext>) => {
  const { spacing } = useTheme();

  const {
    markdownRemark: post,
    allMarkdownRemark: { edges: otherLangPosts },
  } = data;
  const viewCount = usePostViewCount(post?.fields?.slug ?? '');

  assert(post != null, '포스트 데이터를 찾을 수 없습니다.');

  const tableOfContents = post.tableOfContents ?? '';
  const { previous, next } = pageContext;

  return (
    <Layout
      right={
        <Box
          display={{ xs: 'none', lg: 'block' }}
          sx={{
            marginLeft: spacing(1),
          }}
        >
          <Toc tocHtml={tableOfContents ?? ''} />
        </Box>
      }
      rightSticky={true}
    >
      <Box
        sx={{
          marginBottom: spacing(4),
        }}
      >
        <PostContents post={post} viewCount={viewCount} otherLangPosts={otherLangPosts.map(v => v.node)} />
      </Box>
      <Navigation prev={previous} next={next} />
    </Layout>
  );
};

export default PostPage;
